import { aluminium } from './aluminium'
import { antimony } from './antimony'
import { arsenic } from './arsenic'
import { barium } from './barium'
import { boron } from './boron'
import { cadmium } from './cadmium'
import { chromium } from './chromium'
import { cobalt } from './cobalt'
import { copper } from './copper'
import { gallium } from './gallium'
import { germanium } from './germanium'
import { gold } from './gold'
import { graphite } from './graphite'
import { hafnium } from './hafnium'
import { indium } from './indium'
import { iron } from './iron'
import { lead } from './lead'
import { lithium } from './lithium'
import { magnesium } from './magnesium'
import { manganese } from './manganese'
import { nickel } from './nickel'
import { niobium } from './niobium'
import { palladium } from './palladium'
import { platinum } from './platinum'
import { potassium } from './potassium'
import { rareEarth } from './rare-earth'
import { ruthenium } from './ruthenium'
import { silicon } from './silicon'
import { silver } from './silver'
import { strontium } from './strontium'
import { tantalum } from './tantalum'
import { tellurium } from './tellurium'
import { tin } from './tin'
import { titanium } from './titanium'
import { tungsten } from './tungsten'
import type { Metal } from './types'
import { vanadium } from './vanadium'
import { zinc } from './zinc'
import { zirconium } from './zirconium'

export type { Metal, MetalMine, I18nDescriptor } from './types'

// Declared before the helpers that read it — a hand-maintained list, alphabetical.
export const METALS = [
  aluminium,
  antimony,
  arsenic,
  barium,
  boron,
  cadmium,
  chromium,
  cobalt,
  copper,
  gallium,
  germanium,
  gold,
  graphite,
  hafnium,
  indium,
  iron,
  lead,
  lithium,
  magnesium,
  manganese,
  nickel,
  niobium,
  palladium,
  platinum,
  potassium,
  rareEarth,
  ruthenium,
  silicon,
  silver,
  strontium,
  tantalum,
  tellurium,
  tin,
  titanium,
  tungsten,
  vanadium,
  zinc,
  zirconium,
]

/**
 * The metal a slug points at, or null — the one lookup behind `/metal/:id` and `?metal=`
 * alike. Mirrors `articleBySlug`, and takes `string | null` for the same reason: callers
 * hand it a route param straight, without a guard of their own.
 */
export const metalBySlug = (slug: string | null) =>
  METALS.find((m) => m.slug === slug) ?? null

/** The metals authored as related to this one, in the order they were authored. */
export const relatedMetals = (slug: string) =>
  (metalBySlug(slug)?.related ?? [])
    .map((related) => metalBySlug(related))
    .filter((m): m is Metal => Boolean(m))
